import './App.css';
import { Route, Routes } from 'react-router-dom';
// import { Heading } from '@chakra-ui/react';

import Login from './components/Auth/Login/Login';
import Signup from './components/Auth/Register/signup';

import Header from './components/Header/header';
import Footer from './components/Footer/footer';

import HomePage from './components/Home';
import Dashboard from './components/Dashboard';
import AddExpense from './components/Dashboard/AddExpense';
import Protected from './components/Auth/protected';
import { useSelector } from 'react-redux';
import AddBudget from './components/Dashboard/AddBudget';


function App() {
  const auth = useSelector(state => state.auth.isLoggedIn)
  return (
    <div className="App">
      <Header />  
     <Routes>
       <Route path="/" element={<HomePage />}/>
       <Route path='login' element={<Login />}/>
       <Route path='signup' element={<Signup />} />

      
       <Route path='dashboard' element={<Protected isLoggedIn={auth}><Dashboard /></Protected>} />
        <Route path='expense' element={<AddExpense />}/>
        <Route path='budget' element={<AddBudget />}/>
     </Routes>
     <Footer />
    </div>
  );
}

export default App;
